/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerHatchery } from '../../models/customer-hatchery';
import { CustomerHatcheryDto } from '../../models/customer-hatchery-dto';

export interface UpdateCustomerHatchery$Params {
  customerHatcheryId: number;
      body: CustomerHatcheryDto
}

export function updateCustomerHatchery(http: HttpClient, rootUrl: string, params: UpdateCustomerHatchery$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerHatchery>> {
  const rb = new RequestBuilder(rootUrl, updateCustomerHatchery.PATH, 'put');
  if (params) {
    rb.path('customerHatcheryId', params.customerHatcheryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerHatchery>;
    })
  );
}

updateCustomerHatchery.PATH = '/api/customer/hatchery/{customerHatcheryId}';
